import React from 'react';
import { NCZIContactPerson } from '../../../../Interfaces/ncziPatientInformations';
import ElectronicHealthCardContactInfoContactPerson from './ElectronicHealthCardContactInfoContactPerson';
// @ts-ignore
import styles from './ElectronicHealthCardContactInfoContactPersons.module.scss';
import LinkButton from '../../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../../Enums/Theme.enum';
import ScrollContainer from '../../../../../Base/Components/ScrollContainer';

interface Props {
	contacts: NCZIContactPerson[];
	patientIdentifier: string;
	handleReloadData?: () => void;
	handleAdd: () => void;
}

const ElectronicHealthCardContactInfoContactPersons: React.FC<Props> = ({
	contacts,
	patientIdentifier,
	handleReloadData,
	handleAdd,
}) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.controls}>
				<LinkButton
					title={'Přidat kontaktní osobu'}
					theme={Theme.BLUE}
					onClick={() => handleAdd()}
				/>
			</div>
			<ScrollContainer>
				<div className={styles.content}>
					{contacts.map(contact => (
						<ElectronicHealthCardContactInfoContactPerson
							key={contact.rcId}
							contact={contact}
							patientIdentifier={patientIdentifier}
							handleReloadData={handleReloadData}
						/>
					))}
				</div>
			</ScrollContainer>
		</div>
	);
};

export default ElectronicHealthCardContactInfoContactPersons;
